module.exports = __webpack_public_path__ + "img/txt_info1.ab333ff3.png";